// @flow
import * as React from 'react';

import { useStore } from 'react-redux';

import { selectAuthenticatedUserInfos } from '@gandi/authentication';
import { selectFromConfig } from '@gandi/redux-config';
import { selectPersonal } from '@gandi/redux-sharing';
import { useTranslator, localeSelector } from '@gandi/translate';

import { withAssetPath, type WithAssetPath } from 'gandi.react-asset-path';

import { useAppSelector } from 'src/hooks/useAppSelector';

import type { LayoutUrls } from 'src/modules/app/selectors';

import { selectShopCurrent } from '../../../modules/organization/selectors';

import ChatWithUsButton from './ChatWithUsButton';
import CookieConsentDialog from './CookieConsentDialog';
import * as livechat from './modules/livechat';

import styles from './ChatWidget.scss';

// XXX: refactor, same as src/modules/app/selectors
const selectLayoutUrls = selectFromConfig<LayoutUrls>('app.layout.urls', {});

export type Props = {
  assetPath: string => string,
};

function Chat({ assetPath }: Props): React.MixedElement | null {
  const translator = useTranslator();
  const locale = useAppSelector(localeSelector);
  const sharingDetails = useAppSelector(state =>
    selectShopCurrent(state, false),
  );
  const personalDetails = useAppSelector(selectPersonal);
  const publicUrls = useAppSelector(selectLayoutUrls);
  const userInfos = useAppSelector(selectAuthenticatedUserInfos);

  // $FlowFixMe[underconstrained-implicit-instantiation]
  const { getState } = useStore();

  const [consentDialogOpened, setConsentDialogOpened] = React.useState(false);
  const [cookieAccepted, setCookieAccepted] = React.useState(true);

  function initChat({
    justAcceptedCookies,
  }: {
    justAcceptedCookies: boolean,
    ...
  }) {
    livechat.loadZopim({
      translator,
      locale,
      assetPath,
      personalDetails,
      sharingDetails,
      userInfos,
      publicUrls,
      justAcceptedCookies,
      getState,
    });
  }

  // check cookies consent on mount
  React.useEffect(() => {
    if (livechat.isZopimCookieConsented()) {
      initChat({ justAcceptedCookies: false });
    } else {
      setCookieAccepted(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (cookieAccepted) {
    return null;
  }

  return (
    <div className={styles.root}>
      {consentDialogOpened ? (
        <CookieConsentDialog
          onClickAcceptCookies={() => {
            livechat.setCookie();
            initChat({ justAcceptedCookies: true });
            setCookieAccepted(true);
          }}
          onClickCloseBox={() => setConsentDialogOpened(false)}
        />
      ) : (
        <ChatWithUsButton onClick={() => setConsentDialogOpened(true)} />
      )}
    </div>
  );
}

export default (withAssetPath<typeof Chat>(Chat): WithAssetPath<typeof Chat>);
